module.exports = __webpack_public_path__ + "static/img/icon_partner_foxconn.e17b3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_foxconn.png
// module id = eYU+
// module chunks = 1